export default __webpack_public_path__ + "static/media/world.78b759c6.svg";